export type AdSize = 'small' | 'medium' | 'large';

export type AdMeta = {
  note: string;
  displayText: string;
  phoneNumber: string;
  displaySeconds: number;
  size: AdSize;
};

const defaults: AdMeta = {
  note: '',
  displayText: '',
  phoneNumber: '',
  displaySeconds: 5,
  size: 'medium',
};

export function clampDisplaySeconds(value: unknown) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return defaults.displaySeconds;
  return Math.min(60, Math.max(2, Math.round(parsed)));
}

export function normalizeAdSize(value: unknown): AdSize {
  if (value === 'small' || value === 'large') return value;
  return 'medium';
}

export function parseAdMeta(body: string | null | undefined): AdMeta {
  if (!body) return { ...defaults };

  try {
    const parsed = JSON.parse(body) as Partial<AdMeta> & { __adMetaVersion?: number };
    if (parsed && typeof parsed === 'object' && parsed.__adMetaVersion === 1) {
      return {
        note: typeof parsed.note === 'string' ? parsed.note : '',
        displayText: typeof parsed.displayText === 'string' ? parsed.displayText : '',
        phoneNumber: typeof parsed.phoneNumber === 'string' ? parsed.phoneNumber : '',
        displaySeconds: clampDisplaySeconds(parsed.displaySeconds),
        size: normalizeAdSize(parsed.size),
      };
    }
  } catch {
    // الإعلانات القديمة كانت تخزن الملاحظة كنص عادي.
  }

  return { ...defaults, note: body };
}

export function serializeAdMeta(meta: AdMeta) {
  return JSON.stringify({
    __adMetaVersion: 1,
    note: meta.note.trim(),
    displayText: meta.displayText.trim(),
    phoneNumber: meta.phoneNumber.trim(),
    displaySeconds: clampDisplaySeconds(meta.displaySeconds),
    size: normalizeAdSize(meta.size),
  });
}

export function phoneHref(phoneNumber: string) {
  const normalized = phoneNumber.trim().replace(/[^+\d]/g, '');
  return normalized ? `tel:${normalized}` : '';
}
